var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCirclePlusGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.656,
    height: 15.656,
    viewBox: "0 0 15.656 15.656",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-plus-circle",
    d: "M8.391.563a7.828,7.828,0,1,0,7.828,7.828A7.827,7.827,0,0,0,8.391.563Zm4.545,8.712a.38.38,0,0,1-.379.379h-2.9v2.9a.38.38,0,0,1-.379.379H7.507a.38.38,0,0,1-.379-.379v-2.9h-2.9a.38.38,0,0,1-.379-.379V7.507a.38.38,0,0,1,.379-.379h2.9v-2.9a.38.38,0,0,1,.379-.379H9.274a.38.38,0,0,1,.379.379v2.9h2.9a.38.38,0,0,1,.379.379Z",
    transform: "translate(-0.563 -0.563)",
    fill: "#2e9642"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCirclePlusGreen);
export default __webpack_public_path__ + "static/media/circle_plus_green.bc64fcb69cd7c55ea50a70ab3ce8794c.svg";
export { ForwardRef as ReactComponent };